import { render, staticRenderFns } from "./CarpoolItem.component.vue?vue&type=template&id=bf3ccd38&"
import script from "./CarpoolItem.component.vue?vue&type=script&lang=js&"
export * from "./CarpoolItem.component.vue?vue&type=script&lang=js&"
import style0 from "./CarpoolItem.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports